export default {"src":"/_next/static/media/team-icon.b6f43c45.svg","height":512,"width":512};